(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oem-vs-bimmer-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!window.oemComparisonColumnToggleHandler) {
    window.oemComparisonColumnToggleHandler = true;

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-oem-comparison-column]');

      if (!toggle) return;

      const tableWrap = toggle.closest('.oem-comparison__table-wrap');

      if (!tableWrap) return;

      const activeColumn = toggle.dataset.oemComparisonColumn;
      tableWrap.dataset.activeColumn = activeColumn;

      tableWrap.querySelectorAll('[data-oem-comparison-column]').forEach((button) => {
        const isActive = button.dataset.oemComparisonColumn === activeColumn;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
